import * as firebase from 'firebase';
import { HotelBedCatalogData } from '../../shared/index';
import { generateReqAvailablePath } from '../../utils/booking-utils';
import { getAjaxhelper } from '../../utils/index';
import { HAVE_DATA_STATES, HotelRequestCheckerTool, NEED_RECHECK_STATES, TASK_COMPLETE_STATES } from '../HotelRequestCheckerTool';
import { TimerBasedHotelRequestCheckerTool } from './TimerBasedHotelRequestCheckerTool';

/**
 * checker dengan memakai firebase realtime db
 */
export class FirebaseRealtimeDbBasedHotelRequestCheckerTool implements HotelRequestCheckerTool {
    static COMPARED_FIELDS: string[] = ['statusCode', 'processedDetailCount', 'detailCount', 'ountBatchExecuted'];
    /**
     * checker dengan timer
     */
    private timedChecker: TimerBasedHotelRequestCheckerTool | any = null!;
    /**
     * database reference
     */
    private dataRef: firebase.database.Reference | any;

    /**
     * data pengecekan sebelumnya. 
     */
    private prevData: any;

    constructor(private parameter: {
        /**
         * reference ke firebase admin
         */
        realtimeDb: firebase.database.Database;
        /**
         * uuid dari firestore user
         */
        uuid: string;
        /**
         * ini di pakai kalau check path di kirimkan dari pemanggil. misal pas req available return check path
         */
        checkPath?: string ; 
        /**
         * handler kalau perubahan data
         */
        onRequestHeaderDataChange?: (requestHeader: HotelBedCatalogData.ReqHotelAvailable) => any;
        /**
         * handler kalau ada error
         */
        onCheckResultError?: (exc: any) => any;
        /**
         * handler kalau task sudah complete
         */
        onCheckComplete: (requestHeader: HotelBedCatalogData.ReqHotelAvailable) => any;
    }) {

    }

    runCheck(reqKey: string) {
        const className: string = (this as any).constructor.name;
        const methodName: string = 'runCheck';
        const loggerPrefix: string = `[${className}#${methodName}]`;
        const pathDb: string = this.parameter.checkPath && this.parameter.checkPath.length > 0  ?  this.parameter.checkPath :  generateReqAvailablePath({ uuid: this.parameter.uuid, reqKey: reqKey }).substr(1);
        this.dataRef = this.parameter.realtimeDb.ref(pathDb);
        const deployTimedChecking: () => any = () => {
            this.timedChecker = new TimerBasedHotelRequestCheckerTool({
                checkDuration: 1000,
                onCheckComplete: this.parameter.onCheckComplete,
                onCheckResultError: this.parameter.onCheckResultError,
                onRequestHeaderDataChange: this.parameter.onRequestHeaderDataChange
            });
            console.warn(`${loggerPrefix}Data tidak di temukan dalam realtime db. data di check dengan timer`);
            this.detachListener();
        };
        const onListenToFirebaseError: (err: any) => any = (err: any) => {
            this.detachListener();
            console.error(`${loggerPrefix} gagal memasang listener.error: `, err, '.Time based checking di pasang');
            deployTimedChecking();
        };
        // ini handler kalau menerima data dari firebase
        const onValueRecievedHandler: (a: firebase.database.DataSnapshot, b?: string) => any = (a: firebase.database.DataSnapshot, b?: string) => {
            if (a) {
                if (!a.exists()) {
                    deployTimedChecking();
                    return;
                } else {
                    const reqData: any = a.val();
                    console.log(`${loggerPrefix} [NOTIFIKASI] data: `, reqData);
                    if (reqData.statusCode === 'AVAILABLE') {
                        this.detachListener();
                        this.requestForData(reqKey);
                    } else {
                        let haveChange: boolean = false;
                        if (!this.prevData) {
                            haveChange = true;
                        } else {
                            for (let k of FirebaseRealtimeDbBasedHotelRequestCheckerTool.COMPARED_FIELDS) {
                                if (this.prevData[k] !== reqData[k]) {
                                    haveChange = true;
                                    break;
                                }
                            }
                        }
                        if (haveChange) {
                            this.requestForData(reqKey);
                        }
                        this.prevData = reqData;
                    }

                }
            } else {
                deployTimedChecking();
            }
        };
        this.dataRef.on('value', onValueRecievedHandler, onListenToFirebaseError);
    }
    runCheckWithReqAvailibilityHeaderData(reqAvailableHeader: HotelBedCatalogData.ReqHotelAvailable) {
        if (TASK_COMPLETE_STATES.indexOf(reqAvailableHeader.statusCode!) >= 0) {
            this.parameter.onCheckComplete(reqAvailableHeader);
            return;
        }
        if (HAVE_DATA_STATES.indexOf(reqAvailableHeader.statusCode!) >= 0) {
            this.parameter.onRequestHeaderDataChange!(reqAvailableHeader);
        }
        if (NEED_RECHECK_STATES.indexOf(reqAvailableHeader.statusCode!) >= 0) {
            this.runCheck(reqAvailableHeader.reqKey!);
        }
    }
    stopChecker() {
        this.detachListener();
        if (this.timedChecker) {
            this.timedChecker.stopChecker();
            this.timedChecker = null;
        }
    }
    private requestForData(reqKey: string) {
        //
        const clsName: string = (this as any).constructor.name;
        const mthd: string = 'requestForData';
        const prfx: string = `[${clsName}#${mthd}]`;
        getAjaxhelper().get(`/dynamics/rest-api/generic/ReqHotelAvailable/${reqKey}`)
            .then((dtl: HotelBedCatalogData.ReqHotelAvailable) => {
                //
                if (dtl.statusCode === 'AVAILABLE' || dtl.statusCode === 'COMPLETE-WITH-ERROR' || dtl.statusCode === 'NOTAVAILABLE') {
                    this.parameter.onCheckComplete(dtl);
                    this.stopChecker();
                    return;
                }
                this.parameter.onRequestHeaderDataChange!(dtl);
            })
            .catch((exc: any) => {
                this.stopChecker();
                if (this.parameter.onCheckResultError) {
                    this.parameter.onCheckResultError(exc);
                }
                //
                console.error(`${prfx} gagal membaca data request header. error: `, exc);
            });
    }
    private detachListener() {
        const className: string = (this as any).constructor.name;
        const methodName: string = 'detachListener';
        const loggerPrefix: string = `[${className}#${methodName}]`;
        if (this.dataRef) {
            try {
                this.dataRef.off('value');
                this.dataRef = null;
            } catch (exc) {
                console.error(`${loggerPrefix} gagal detach listener`);
            }

        }
    }
}


// WEBPACK FOOTER //
// ./src/hotels/req-available/FirebaseRealtimeDbBasedHotelRequestCheckerTool.ts